<template>
  <div>
    <DiffHeader :mbB="value.mbB" :mbA="value.mbA" class="mb-6" />
    <DiffTable :cols="cols" :pairs="pairs" :mbB="value.mbB" :mbA="value.mbA" />
  </div>
</template>

<script>
import DiffTable from './DiffTable.vue'
import DiffHeader from './DiffHeader.vue'
import { missingOne } from './compare-utils.js'

export default {
  components: { DiffTable, DiffHeader },
  props: {
    value: { required: true },
    showAll: { type: Boolean, default: false }
  },
  data() {
    return {
      cols: [
        { label: 'ID', prop: 'id' },
        { label: 'Name', prop: 'name' },
        { label: 'Updated', prop: 'updated' }
      ]
    }
  },
  computed: {
    pairs() {
      if (this.showAll) return this.value.pairs
      return this.value.pairs.filter(missingOne)
    }
  }
}
</script>

<style></style>
